module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.a921eb29.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Black.ttf
// module id = 3782
// module chunks = 70